import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/Cart.css";
import { Link, useNavigate } from "react-router-dom";
import { arrow, no_image_product_details } from "../../constant";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import NoRecord from "../../Components/NoRecord/NoRecord";
import { useDispatch, useSelector } from "react-redux";
import {
  ClearCart,
  DecrementProductQuantity,
  deleteCartItem,
  IncrementProductQuantity,
  UpdateCart,
} from "../../redux/actions/CartActions";
import { toast } from "react-toastify";

function Cart() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartDataRedux = useSelector((state) => state.CartReducer.cartData);
  const DeliveryDateRedux = useSelector(
    (state) => state.CartReducer.deliveryDates
  );
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const isLogin = useSelector((state) => state.AuthReducer.isLogin);
  const [cartData, setCartData] = useState(cartDataRedux);
  const [subTotal, setSubTotal] = useState(0);
  const [deliveryDate, setDeliveryDate] = useState();
  const [totalDonation, setTotalDonation] = useState(0);
  const [frequentData, setFrequentData] = useState([]);

  const TotalAmount = () => {
    let i;
    let total = 0;
    let donationTotal = 0;
    for (i = 0; i < cartDataRedux.length; i++) {
      if (cartDataRedux[i]?.campaign_price) {
        donationTotal =
          parseInt(donationTotal) + parseInt(cartDataRedux[i]?.campaign_price);
      }
      if (cartDataRedux[i]?.type && cartDataRedux[i]?.type == "bulk") {
        total = total + cartDataRedux[i]?.price * 1;
      } else {
        total = total + cartDataRedux[i]?.price * cartDataRedux[i]?.quantity;
      }
      if (cartDataRedux[i]?.campaign_price) {
        total = parseInt(total) + parseInt(cartDataRedux[i]?.campaign_price);
      }
      if (cartDataRedux[i]?.addon_item) {
        let j;
        for (j = 0; j < cartDataRedux[i]?.addon_item.length; j++) {
          total =
            parseInt(total) +
            parseInt(
              cartDataRedux[i]?.addon_item[j]?.addon_item
                ? cartDataRedux[i]?.addon_item[j]?.addon_item[0]?.variation[0]
                    ?.price
                : 0
            );
        }
      }
    }
    setSubTotal(total);
    setTotalDonation(donationTotal);
  };

  useEffect(() => {
    TotalAmount();
  }, [cartDataRedux]);

  useEffect(() => {
    let result = [];
    if (cartDataRedux?.length > 0) {
      async function AllFrequent() {
        for (let i = 0; i < cartDataRedux?.length; i++) {
          for (
            let j = 0;
            j < cartDataRedux[i]?.productitem?.frequent_products?.length;
            j++
          ) {
            result.push(cartDataRedux[i]?.productitem?.frequent_products[j]);
          }
        }
        await RemoveDuplicateFrequent(result);
      }
      AllFrequent();
    }
  }, []);

  const RemoveDuplicateFrequent = async (result) => {
    if (result?.length > 0) {
      const map = new Map();
      const result2 = [];
      for (const item of result) {
        if (!map.has(item?.id)) {
          map.set(item?.id, true);
          result2.push(item);
        }
      }
      setFrequentData(result2);
    }
  };

  const Increment = (id) => {
    dispatch(IncrementProductQuantity(id));
  };
  const Decrement = (id) => {
    dispatch(DecrementProductQuantity(id));
  };

  const RemoveCartItem = (id) => {
    const items = cartData;
    let currentItem = id;
    if (items.length > 0) {
      setCartData(
        items.filter((item, index) => item?.productitem?.id !== currentItem)
      );
      dispatch(deleteCartItem(currentItem));
    }
  };

  const filterVariationQty = (item) => {
    let varient = item?.size;
    if (item?.productitem?.variation.length > 0) {
      let newVarient = item?.productitem?.variation?.filter(
        (val) => val?.size == item?.size
      );
      if (newVarient?.length > 0) {
        return newVarient[0]?.qty || 1;
      }
      return 1;
    }
    return 1;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const LoginHandler = (e) => {
    e.preventDefault();
    if (!isLogin) {
      toast.error("Please Login");
      navigate("/login");
      return;
    }
    if (cartDataRedux?.length < 1) {
      toast.error("Please Add Products ");
      return;
    }
  };

  const DeliveryDateHandler = (e, id) => {
    const items = cartData;
    if (items.length > 0) {
      let i;
      for (i = 0; i < cartDataRedux.length; i++) {
        if (cartDataRedux[i]?.productitem?.id === id) {
          items[i] = {
            id: cartDataRedux[i]?.id,
            price: cartDataRedux[i]?.price,
            quantity: cartDataRedux[i]?.quantity,
            size: cartDataRedux[i]?.size,
            campaign_price: cartDataRedux[i]?.campaign_price,
            campaign_id: cartDataRedux[i]?.campaign_id,
            productitem: cartDataRedux[i]?.productitem,
            deliveryDate: e.target.value,
            addon_item: cartDataRedux[i]?.addon_item,
            // addon_id: cartDataRedux[i]?.addon_id,
            type: cartDataRedux[i]?.type,

            product_variant_id: cartDataRedux[i]?.product_variant_id,
          };
        }
      }
      dispatch(UpdateCart(items));
    }
  };

  const SpecificItemHandler = (item) => {
    let i;
    let total = 0;
    for (i = 0; i < item.length; i++) {
      total =
        parseInt(total) +
        parseInt(
          item[i]?.addon_item ? item[i]?.addon_item[0]?.variation[0]?.price : 0
        );
    }
    return total;
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  return (
    <>
      <Header />
      <MainBanner name={"Shopping Cart"} />
      <section className="cart-page">
        <div className="container">
          <div className="container">
            <div className="row pb-5">
              <div className="col-lg-12 col-12">
                <div className="cart-table-wrapper">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col">Product Name</th>
                          <th scope="col">Detail</th>
                          <th scope="col">Addons</th>
                          <th scope="col">Price</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Sub Total</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {cartDataRedux?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className="pro-img">
                                <div className="img-wrapper">
                                  <img
                                    src={
                                      item?.productitem?.thumbnail
                                        ? `${ImageUrlRedux?.product_thumbnail_url}/${item?.productitem?.thumbnail}`
                                        : no_image_product_details
                                    }
                                    className="img-fluid thumbnail_small_image"
                                    alt=""
                                  />
                                </div>
                              </td>
                              <td className="pro-name">
                                <div className="one_line_clamp">
                                  {item?.productitem?.name}
                                </div>

                                {item?.productitem?.category?.name ==
                                "All Plants" ? (
                                  <select
                                    onChange={(e) =>
                                      DeliveryDateHandler(
                                        e,
                                        item?.productitem?.id
                                      )
                                    }
                                  >
                                    <option disabled>
                                      Select Delivery Date
                                    </option>
                                    {DeliveryDateRedux?.map((item, index) => {
                                      // <option disabled></option>
                                      return (
                                        <option value={item} key={index}>
                                          {item}
                                        </option>
                                      );
                                    })}
                                  </select>
                                ) : null}
                              </td>
                              <td className="pro-name main-card-control">
                                {/* Color: {item?.color} */}
                                {/* <br /> */}
                                {item?.productitem?.category?.name ? (
                                  <>
                                    <span>
                                      {item?.productitem?.category?.name}
                                    </span>
                                    <br />
                                  </>
                                ) : null}
                                {item?.size ? (
                                  <span>
                                    {item?.size} size
                                    {filterVariationQty(item) > 0 &&
                                    filterVariationQty(item) < 10 ? (
                                      <>
                                        : only {filterVariationQty(item)}{" "}
                                        {filterVariationQty(item) > 1
                                          ? "items"
                                          : "item"}{" "}
                                        left
                                      </>
                                    ) : null}
                                  </span>
                                ) : null}

                                <br />
                                {item?.type == "bulk" ? (
                                  <span>{item?.type}</span>
                                ) : null}
                              </td>

                              <td className="pro-name main-card-control">
                                {item?.addon_item?.length > 0 ? (
                                  <>
                                    {item?.addon_item?.map((item) => {
                                      return (
                                        <p
                                          className="variation-type"
                                          key={item?.addon_item[0]?.id}
                                        >
                                          {item?.addon_item[0]?.name} $
                                          {item?.addon_item[0]?.variation[0]
                                            ? item?.addon_item[0]?.variation[0]
                                                ?.price
                                            : null}{" "}
                                          {item?.addon_item[0]?.variation[0]
                                            ? item?.addon_item[0]?.variation[0]
                                                ?.size
                                            : null}
                                        </p>
                                      );
                                    })}
                                  </>
                                ) : (
                                  <p className="variation-type">$0</p>
                                )}
                              </td>

                              <td className="total-price settotal-price">
                                $ {item?.price}
                              </td>
                              <td>
                                <div className="number">
                                  <button
                                    className="minus"
                                    onClick={() =>
                                      Decrement(item?.productitem?.id)
                                    }
                                    disabled={
                                      item?.quantity <= 1 ||
                                      item?.type == "bulk"
                                    }
                                  >
                                    -
                                  </button>
                                  <span> {item?.quantity}</span>
                                  <button
                                    className="plus"
                                    onClick={() =>
                                      Increment(item?.productitem?.id)
                                    }
                                    disabled={
                                      item?.type == "bulk" ||
                                      filterVariationQty(item) == item?.quantity
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="sub-total">
                                <h4 className="subtotal">
                                  {item?.type == "bulk" ? (
                                    <>
                                      $
                                      {item?.addon_item
                                        ? parseInt(item?.price) *
                                          parseInt(item?.quantity)
                                        : item?.price}
                                    </>
                                  ) : (
                                    <>
                                      $
                                      {item?.addon_item
                                        ? item?.quantity * item?.price +
                                          SpecificItemHandler(item?.addon_item)
                                        : // parseInt(
                                          //   item?.addon_variationPrice
                                          // ) * parseInt(
                                          //   item?.addonQuantity
                                          // )
                                          item?.quantity * item?.price}
                                    </>
                                  )}
                                </h4>
                              </td>
                              <td className="close-row">
                                <button
                                  onClick={(e) =>
                                    RemoveCartItem(item?.productitem?.id)
                                  }
                                >
                                  {" "}
                                  <CloseIcon className="seticon" />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {cartDataRedux.length > 0 ? null : <NoRecord />}
                  </div>

                  <div className="row">
                    <div className="col-md-7"></div>
                    <div className="col-md-5">
                      <div className="button-group">
                        <button
                          className="btn continueBtn"
                          onClick={(e) => navigate("/all-plants")}
                        >
                          Continue Shopping
                        </button>
                        <button
                          className="btn clearBtn"
                          onClick={(e) => dispatch(ClearCart())}
                        >
                          Clear Cart
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {cartDataRedux?.[0]?.productitem ? (
              <div className="row">
                <div className="col-lg-6">
                  <div className="cart-t-tal-wrapper">
                    <div className="cart-content-wrapper">
                      <ul>
                        <li>
                          <span className="property">Donation :</span>
                          <span className="value">
                            ${totalDonation ? totalDonation : 0}
                          </span>
                        </li>
                        <li>
                          <span className="property">Subtotal :</span>
                          <span className="value">$ {subTotal}</span>
                        </li>
                        <li>
                          <span className="property">
                            Estimated Shipping Cost :
                          </span>
                          <span className="value">Free Shipping</span>
                        </li>
                      </ul>
                    </div>
                    <div className="cart-footer-wrapper">
                      <ul>
                        <li>
                          <span className="property">TOTAL COST :</span>{" "}
                          <span className="value">$ {subTotal}</span>{" "}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className={"col-lg-6"}>
                  <div className={"checkout-cont"}>
                    {isLogin && cartDataRedux?.length > 0 ? (
                      <Link
                        to={`/check-out`}
                        state={{
                          data: {
                            CartData: cartDataRedux,
                            total: subTotal,
                            // couponData: couponData,
                          },
                        }}
                        className="btn a-checkout"
                      >
                        Continue To checkout
                      </Link>
                    ) : (
                      <button
                        className="btn checkoutBtn"
                        onClick={(e) => LoginHandler(e)}
                      >
                        Continue To checkout &nbsp;&nbsp;
                        <img src={arrow} className="image-fluid" alt="" />{" "}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>

      {frequentData?.length > 0 ? (
        <section className="cart-frequentProduct">
          <div className="container">
            <h4 className="mb-4">Don't Forget These:</h4>
            <div className="row">
              {frequentData?.map((item, index) => {
                return (
                  <>
                    {index < 4 ? (
                      <div className="col-lg-3 col-md-6 mb-3" key={index}>
                        <div
                          className={`${
                            index == 3 ? "product-box" : "product-box "
                          }`}
                          // pro_boxs
                          id="multi_select"
                        >
                          <Link to={`/product-detail/${item?.id}`}>
                            <div
                              className={"pro-img"}
                              // onClick={(e) => AddFrequentHandler(e, item)}
                            >
                              <figure>
                                <img
                                  src={
                                    item?.thumbnail
                                      ? `${ImageUrlRedux?.product_thumbnail_url}/${item?.thumbnail}`
                                      : `${no_image_product_details}`
                                  }
                                  alt=""
                                  className="img-fluid"
                                />
                              </figure>
                            </div>
                            <div className="pro-detail">
                              <div className="name">
                                <h4>{item?.name}</h4>
                              </div>
                              <div className="price">
                                <h4>${item?.unit_price}</h4>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ) : null}
                  </>
                );
              })}
            </div>
          </div>
        </section>
      ) : null}

      <Footer />
    </>
  );
}

export default Cart;
